import * as ReportViewTypes from '../views/report/types';
import type * as ReportDraftViewTypes from '../views/reportDraft/types';
import type * as ViewTypes from '../views/types';

export const REPORT_VIEW_TYPE = ReportViewTypes.REPORT_VIEW_TYPE;
export const REPORT_DRAFT_VIEW_TYPE = ReportViewTypes.REPORT_DRAFT_VIEW_TYPE;

export type ReportViewRef =
  | ReportViewTypes.ReportLikeViewRef
  | ReportDraftViewTypes.ViewRef;

export type ReportRef =
  | ReportViewTypes.ReportLikeRef
  | ReportDraftViewTypes.Ref;

export function isReportRef(ref: ViewTypes.ViewPartRefs): ref is ReportRef {
  return ReportViewTypes.isReportLikeViewType(ref.type);
}

export interface StateType {
  viewRefs: {[id: string]: ReportViewRef};
  pushedRef: string | null;
  loading: boolean;
  noAccess: boolean;
}

export interface PushReportOpts {
  redirectQS?: {[key: string]: string | null};
  newTab?: true;
}
